// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pdf-page {\n  display: block;\n  margin: auto;\n}\n.box-shadow {\n  /* box-shadow: rgb(0 0 0 / 10%) 0px 5px 10px 0px, rgb(0 0 0 / 30%) 0px 60px 100px -60px;\n  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08); */\n  -webkit-box-shadow: 0px 7px 4px rgba(0, 0, 0, 0.25);\n          box-shadow: 0px 7px 4px rgba(0, 0, 0, 0.25);\n  /* box-shadow: rgb(0 0 0 / 10%) 0px 5px 10px 0px, rgb(0 0 0 / 30%) 0px 60px 100px -60px; */\n}\n", ""]);
// Exports
module.exports = exports;
